import React, { useEffect, useRef, useState } from 'react';
import { Form, Upload } from 'antd';
import {
    FileImageOutlined,
    FileOutlined,
    FilePdfOutlined,
    FileZipOutlined,
    InboxOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import ReactDOM from 'react-dom';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

var url = "https://kehilaapi.syn-assist.fr/v1/forms/upload"
if (process.env.NODE_ENV === "production") {
    url = "https://api.kehila.syn-assist.fr/v1/forms/upload"
}

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {
            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)

            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props
            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            var multiple = data.multiple || false
            var prefix = multiple ? "[DOCUMENT_MULTI]_" : "[DOCUMENT]_"

            var Icon = <InboxOutlined />
            var accept = "image/*,application/*"

            switch (data.type) {
                case formPlugin.UPLOAD_TYPE[0]:
                    Icon = <FileImageOutlined />
                    accept = "image/*"
                    break;
                case formPlugin.UPLOAD_TYPE[1]:
                    Icon = <FilePdfOutlined />
                    accept = "application/pdf"
                    break;
                case formPlugin.UPLOAD_TYPE[2]:
                    Icon = <FileZipOutlined />
                    accept = "application/zip"
                    break;
            }

            const listFieldProps = listField ? listField : null
            const finalName = prefix + data.fieldKey

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={(data.label || t`Fichier`) + " :"}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <ValueToFileList multiple={multiple}>
                            <Upload.Dragger
                                multiple={multiple}
                                maxCount={multiple ? data.maxCount : 1}
                                action={url}
                                listType="picture"
                                accept={accept}
                            >
                                <p className="ant-upload-drag-icon">
                                    {Icon}
                                </p>
                                <p className="ant-upload-text">
                                    <Trans>Cliquez ou faites glisser le fichier dans cette zone pour le télécharger</Trans>
                                </p>
                                <p className="ant-upload-hint">{data.placeholder}</p>
                            </Upload.Dragger>
                        </ValueToFileList>
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-upload' + namespace,
        title: t`Fichier`,
        description: t`Élément de formulaire utilisable.`,
        icon: <FileOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    multiple: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Plusieurs Fichiers`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-Étiquette`,
                            placeholder: t`Sous-Étiquette`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                    type: {
                        type: "string",
                        uniforms: {
                            label: t`Type de Fichier`,
                            allowedValues: formPlugin.UPLOAD_TYPE,
                        }
                    },
                }
            },
        },
    }
}

export function ValueToFileList({ multiple, value, onChange, children }) {

    const convertToFileList = (v) => {
        if (!v) return []
        let finalValue = multiple ? v : [v]

        return finalValue.map(i => ({
            uid: i.doc,
            name: i.name,
            response: i.doc,
            status: 'done',
        }))
    }

    const convertToValue = (e) => {
        if (multiple) {
            if (Array.isArray(e.fileList)) {
                var values = []
                for (var file of e.fileList) {
                    if (file.status === "done") {
                        values.push({ name: file.name, doc: file.response })
                    }
                }
                return values
            }
            return []
        } else {
            if (e.file && e.file.status === "done") {
                return { name: e.file.name, doc: e.file.response }
            }
            return null
        }
    }

    return React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                defaultFileList: convertToFileList(value),
                onChange: (e) => {
                    const finalValue = convertToValue(e)
                    if (finalValue) {
                        onChange(finalValue)
                    }
                }
            });
        }
        return child;
    })
}
